<template>
  <div class="base-video-autoplay">
    <video
      ref="video"
      playsinline
      autoplay
      muted
      loop
    />
    <transition name="fade">
      <img
        :src="imageBackupUrl"
        v-show="!started"
      >
    </transition>
  </div>
</template>

<script>
import fetchMedia from '@/utils/fetchMedia'
export default {
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    imageBackupUrl: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      started: false,
      loaded: new Promise(async resolve => {
        this.$refs['video'].src = await fetchMedia(this.videoUrl)
        this.$refs['video'].oncanplaythrough = () => resolve
        this.$refs['video'].onplay = () => (this.started = true)
        this.$refs['video'].pause()
        this.$refs['video'].load()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-video-autoplay,
video,
img {
  position: relative;
  width: 100%;
  height: 100%;
}
video,
img {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  display: block;
  object-fit: cover;
  @media #{$media-3} {
    object-fit: fill;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }
}
img {
  z-index: 1;
}
</style>
